(function () {
    'use strict';

    drvEntityFieldInput.$inject = [];
    drvEntityFieldInputCtrl.$inject = [];

    angular
        .module('app')
        .directive('drvEntityFieldInput', drvEntityFieldInput);

    function drvEntityFieldInput() {
        return {
            templateUrl: 'app/entity-field-input.tmpl.html',
            require: "ngModel",
            scope: {
                value: '=ngModel',
                field: '=',
                type: '=type',
                fileAttachmentList: '='
            },
            controller: drvEntityFieldInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '=',
                type: '=type',
                fileAttachmentList: '='
            }
        };
    }

    function drvEntityFieldInputCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.addEnumerationValue = addEnumerationValue;
        drvCtrl.removeEnumerationValue = removeEnumerationValue;
        drvCtrl.loadEnumerations = loadEnumerations;
        drvCtrl.updateEnumerationValue = updateEnumerationValue;
        drvCtrl.enumerationDeliminter = ',';

        activate();

        function activate() {
            if (!angular.isUndefined(drvCtrl.type) && !angular.isUndefined(drvCtrl.type.DataType) && drvCtrl.type.DataType === 'enum') {
                drvCtrl.availableEnumerations = [];
                drvCtrl.currentEnumerations = [];
                drvCtrl.loadEnumerations();
            }
        }

        function addEnumerationValue(enumeration) {
            if (!angular.isUndefined(enumeration) && enumeration !== null && enumeration !== '') {
                // Remove enumeration from the available list
                _.remove(drvCtrl.availableEnumerations, function (n) { return n === enumeration; });

                // Add the enumeartion to currentEnumerations and the ng model.
                drvCtrl.currentEnumerations.push(enumeration);
                drvCtrl.selectedEnumeration = null;
            }
        }

        function removeEnumerationValue(enumeration) {
            // Remove the enumeartion from currentEnumerations and the ng model.
            if (!angular.isUndefined(enumeration) && enumeration !== null && enumeration !== '') {
                _.remove(drvCtrl.currentEnumerations, function (n) { return n === enumeration; });

                // Rebuild the available list for enumeartions
                drvCtrl.availableEnumerations = drvCtrl.field.Enumerations.split(drvCtrl.enumerationDeliminter);
                angular.forEach(drvCtrl.currentEnumerations, function (currentEnumeration) {
                    _.remove(drvCtrl.availableEnumerations, function (n) { return n === currentEnumeration; });
                });

                drvCtrl.selectedEnumeration = null;
            }
        }

        function arrayToDelimintedString(array, deliminter) {
            var result = '';
            var firstField = true;

            angular.forEach(array, function (n) {
                if (firstField) {
                    result = n;
                    firstField = false;
                }
                else {
                    result = result + deliminter + n;
                }
            });

            return result;
        }

        function delimintedStringToArray(string, deliminter) {
            var result = string.split(deliminter);

            return result;
        }

        function loadEnumerations() {
            drvCtrl.availableEnumerations = drvCtrl.field.Enumerations.split(drvCtrl.enumerationDeliminter);

            if (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value !== '' && drvCtrl.field.EnumerationType === 'Multiple') {
                drvCtrl.currentEnumerations = drvCtrl.value.split(drvCtrl.enumerationDeliminter);
                angular.forEach(drvCtrl.currentEnumerations, function (enumeration) {
                    _.remove(drvCtrl.availableEnumerations, function (n) { return n === enumeration; });
                });
            }
        }

        function updateEnumerationValue() {
            var enumerationString = arrayToDelimintedString(drvCtrl.currentEnumerations, drvCtrl.enumerationDeliminter);
            drvCtrl.value = enumerationString;
        }
    }
})();